import ActivityBody from './activityBody.view';

export default ActivityBody;
